export enum AssetState {
  SUCEEDED = 'suceeded',
  PROCESSING = 'processing',
}
export interface IAssetItem {
  id: string;
  url: string;
  thumbnail: string;
  assetFile: string;
  index: number;
  hspan?: number;
  state: AssetState;
  data: any;
  acquiredBy: string;
  fav?: boolean;
  caseId?: string;
  sampleId?: string;
}
